__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "auth";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@coremind/identity-core", "1.0.1792203434", () => (() => (__webpack_require__(6787))), 1);
			register("@emotion/react", "11.14.0", () => (() => (__webpack_require__(7727))), 1);
			register("@emotion/styled", "11.14.1", () => (() => (__webpack_require__(2036))), 1);
			register("@mui/icons-material", "7.3.11", () => (() => (__webpack_require__(5082))), 1);
			register("@mui/material", "7.3.11", () => (() => (__webpack_require__(6025))), 1);
			register("@mui/system", "7.3.11", () => (() => (__webpack_require__(179))), 1);
			register("react-dom", "^19.1.1", () => (() => (__webpack_require__(5353))), 1);
			register("react-router-dom", "^7.1.3", () => (() => (__webpack_require__(501))), 1);
			register("react", "^19.1.1", () => (() => (__webpack_require__(2503))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};